<template>
	<div
		v-if="totals"
		class="grid grid-cols-subgrid col-span-full [&>*]:not-first:border-s [&>*]:border-b font-semibold text-sm"
	>
		<div />
		<AppInput
			:model-value="totals.hoogte"
			:value-type="ValueType.Currency"
			:read-only="true"
		/>
		<div />
		<AppInput
			:model-value="totals.looptijd"
			:value-type="ValueType.Number"
			:read-only="true"
		/>
		<div />
		<AppInput
			:model-value="totals.rente"
			:value-type="ValueType.Percentage"
			:read-only="true"
		/>

		<div class="sticky right-0 bg-white z-20 border-l" />
	</div>
</template>

<script setup lang="ts">
import type { LeningdelenTotaaldeel } from "@loanlink-nl/model-app";
import { ValueType } from "@/enums/ValueType";

defineProps<{
	totals?: LeningdelenTotaaldeel;
}>();
</script>
